module.exports = __webpack_public_path__ + "static/media/commerce-landscape.8a9f43f5.jpg";